import {SSD_NAME, SSD_VOLUME_TYPE_OV, StationCycleState, UNDERSCORE} from "../../../Constants";
import get from "lodash/get";
import {CYCLE} from "../../../Constants";

/**
 * Check if cycle + node is dynamic or zoned
 * by their corresponding Cycle Type
 * @param cycleName Name of cycle to be checked.
 * @param nodeId Identifier of the node
 * @param cycleList List of Cycles
 * @returns {boolean}
 */
export const isDynamicCycle = (cycleName, nodeId, cycleList) => {
    if(cycleList)
        for(let cycles of cycleList){
            if((cycles.cycle && cycles.cycle.cycleName && cycles.cycle.cycleName === cycleName)
                && (cycles.stationCode && cycles.stationCode === nodeId)){
                return cycles.cycle.cycleType === "DRS";
            }
        }
    return false;
}

export const isSideline = (cycleName, nodeId, cycleList) => {
    if(cycleList) {
        for(let cycles of cycleList) {
            if((cycles.cycle && cycles.cycle.cycleName === cycleName)
                && (cycles.stationCode && cycles.stationCode === nodeId)
                && (cycles.cycle.cycleType === CYCLE.SIDELINE
                    || cycles.cycle.cycleType === CYCLE.SIDELINE_STATIC)){
                return true;
            }
        }
    }
    return false;
}

/**
 * Check if cycle + node is related to PS-OnGrid
 * by their corresponding Cycle Type
 * @param cycleName Name of cycle to be checked.
 * @param nodeId Identifier of the node
 * @param cycleList List of Cycles
 * @returns {boolean}
 */
export const isPSOnGrid = (cycleName, nodeId, cycleList) => {
    if (cycleList) {
        for (let cycles of cycleList) {
            if ((cycles.cycle && cycles.cycle.cycleName === cycleName)
                && (cycles.stationCode && cycles.stationCode === nodeId)
                && (cycles.cycle.cycleType === CYCLE.PS_ON_GRID)){
                return true;
            }
        }
    }
    return false;
}

/**
 * Check if cycle + node is reverse
 * by their corresponding Cycle Type
 * @param cycleName Name of cycle to be checked.
 * @param nodeId Identifier of the node
 * @param cycleList List of Cycles
 * @returns {boolean}
 */
export const isReverse = (cycleName, nodeId, cycleList) => {
    if(cycleList) {
        for(let cycles of cycleList) {
            if((cycles.cycle && cycles.cycle.cycleName === cycleName)
                && (cycles.stationCode && cycles.stationCode === nodeId)
                && (cycles.cycle.cycleType === CYCLE.REVERSE)){
                return true;
            }
        }
    }
    return false;
}

/**
 * Checks if a cycle is dynamic for a given cycle name and node id.
 *
 * @param cycleToCheck
 * @param cycleList
 * @returns {boolean}
 */
export const isDynamicStationCycle = (cycleToCheck, cycleList) => {
    if(cycleList) {
        for (let stationCycle of cycleList) {
            if (areSameCycles(stationCycle, cycleToCheck)) {
                return stationCycle.cycle.cycleType === "DRS";
            }
        }
    }
    return false;
}

export const isSidelineStationCycle = (cycleToCheck, cycleList) => {
    if(cycleList) {
        for (let stationCycle of cycleList) {
            if (areSameCycles(stationCycle, cycleToCheck)) {
                return stationCycle.cycle.cycleType === CYCLE.SIDELINE
                    || stationCycle.cycle.cycleType === CYCLE.SIDELINE_STATIC;
            }
        }
    }
    return false;
}

/**
 * Checks if two cycles defined by the format StationCycle are same
 * @param cycle1
 * @param cycle2
 * @returns {boolean}
 */
export const areSameCycles = (cycle1, cycle2) => {
    return cycle1[StationCycleState.STATION_CODE] === cycle2[StationCycleState.STATION_CODE]
        && get(cycle1, [StationCycleState.CYCLE, StationCycleState.CYCLE_NAME])
            === get(cycle2, [StationCycleState.CYCLE, StationCycleState.CYCLE_NAME]);
}

/**
 * Get the sort path setting name based on the bin temperature and volume type
 * @param binTemperature
 * @param binVolumeType
 * @returns {string}
 */
export const getGrocerySortPathSettingName = (binTemperature, binVolumeType) => {
    if(binVolumeType && binVolumeType === SSD_VOLUME_TYPE_OV)
        return SSD_NAME + UNDERSCORE + binTemperature + UNDERSCORE + SSD_VOLUME_TYPE_OV;
    else
        return SSD_NAME + UNDERSCORE + binTemperature;
}
